// extracted by mini-css-extract-plugin
export default {"personalInfoList":"AccountInfo_personalInfoList__lLH+f","name":"AccountInfo_name__qX-Nb","password":"AccountInfo_password__Y5woQ"};